import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseEquipmentTypesAdapter = getAdapter({ idFieldName: 'value' });

const warehouseEquipmentTypesSlice = createSlice({
  name: 'warehouseEquipmentTypes',
  initialState: warehouseEquipmentTypesAdapter.getInitialState(),
  reducers: {
    setWarehouseEquipmentTypes: (state, { payload: { equipmentTypes } }) => {
      warehouseEquipmentTypesAdapter.setAll(state, equipmentTypes);
    },
  },
});

const selectors = warehouseEquipmentTypesAdapter.getSelectors(({ warehouseEquipmentTypes }) => warehouseEquipmentTypes);

export const getWarehouseEquipmentTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseEquipmentTypes = (state) => getWarehouseEquipmentTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseEquipmentTypes,
} = warehouseEquipmentTypesSlice.actions;

export default warehouseEquipmentTypesSlice.reducer;
